<template>
    <nav class="navbar navbar-expand-lg navigation fixed-top sticky" id="navbar">
        <div class="container">
            <a class="navbar-logo" href="/">
                <img src="@/assets/images/logo-dark2.png" alt height="40" class="logo logo-dark" />
                <img src="@/assets/images/logo-light2.png" alt height="40" class="logo logo-light" />
            </a>

            <button
                    type="button"
                    class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
                    data-toggle="collapse"
                    data-target="#topnav-menu-content"
                    @click="toggleMenu()"
            >
                <i class="fa fa-fw fa-bars"></i>
            </button>
            <div class="ml-4 text-white font-size-15">Facultad de Ingeniería Civil y Arquitectura</div>
            <div class="collapse navbar-collapse" id="topnav-menu-content">
                <ul
                        class="navbar-nav ml-auto"
                        id="topnav-menu"
                >
                    <li class="nav-item">
                        <router-link :to="{ path: '/home'}" >
                            <a class="nav-link"  href="javascript: void(0);">Inicio</a>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ path: '/login'}" >
                            <a class="nav-link"  href="javascript: void(0);">Intranet</a>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ path: '/expediente-nuevo-externo'}" >
                            <a class="nav-link"  href="javascript: void(0);">Mesa de partes</a>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ path: '/expediente-buscar-externo'}" >
                            <a class="nav-link"  href="javascript: void(0);">Buscar trámite</a>
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <router-link :to="{ path: '/seguimiento-externo'}" >
                            <a class="nav-link"  href="javascript: void(0);">Seguimiento</a>
                        </router-link>
                    </li>
                </ul>

                <!--<div class="ml-lg-2">
                  <a href="javascript: void(0);" class="btn btn-outline-success w-xs">Sign in</a>
                </div>-->
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "expediente-info",
        methods:{
            toggleMenu() {
                document.getElementById("topnav-menu-content").classList.toggle("show");
            },
        }
    }
</script>

<style scoped>

</style>